import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Components/navbar";
import Footer from "../Components/footer";

const MainLayout = ({ currentLang, changeLang }) => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar />

      <main className="flex-grow-1">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default MainLayout;